
const hotelInfo = [

	{	
		id: 101,
		hotelName: 'Rest Inn Hotel Moulvibazar',
		description: 'Standard Single Rooms are designed in open -concept living area and have many facilities.',
		imgUrl: 'https://i.ibb.co/JdYJsH5/hotel-1.jpg',
		bed: 1,
		capacity: 1,
		bedroom: 1,
		baths: 1,
		halfprice: 119,
		totalPrice: 169,
		ratings: 4.9,
		ratingsPerson: 20,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "sreemangal"
	},
	{	
		id: 102,
		hotelName: 'Jungle cottage in Sundarbans',
		description: 'Located in sundarbans, Jungle cottage has free WiFi, and guests can enjoy a restaurant and a garden. Nice place with great location. The staffs were so polite & helpful. will visit again.',
		imgUrl: 'https://i.ibb.co/JdYJsH5/hotel-1.jpg',
		bed: 1,
		capacity: 2,
		bedroom: 1,
		baths: 1,
		halfprice: 129,
		totalPrice: 179,
		ratings: 4.9,
		ratingsPerson: 18,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "sundarbans"
	},
	{	
		id: 103,
		hotelName: 'Balishira Resort Ltd.',
		description: 'Located in Sreemangal, Balishira Resort Ltd. Features a terrace. Among the facilities of this property are a restaurant, a 24-hour front desk and room service, along with free.',
		imgUrl: 'https://i.ibb.co/NnSKgnd/hotel-2.jpg',
		bed: 2,
		capacity: 4,
		bedroom: 2,
		baths: 2,
		halfprice: 229,
		totalPrice: 329,
		ratings: 4.9,
		ratingsPerson: 12,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "sreemangal"
	},
	{	
		id: 104,
		hotelName: 'ParadiseLodge Guest House',
		description: 'Featuring a garden, ParadiseLodge Guest House is located in Sreemangal. Private parking can be arranged at an extra charge. The rooms in the guesthouse are equipped with an electric tea pot.',
		imgUrl: 'https://i.ibb.co/bW6fCDR/hotel-3.jpg',
		bed: 3,
		capacity: 6,
		bedroom: 3,
		baths: 3,
		halfprice: 399,
		totalPrice: 569,
		ratings: 4.9,
		ratingsPerson: 9,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "sreemangal"
	},
	{	
		id: 105,
		hotelName: 'Hotel Skypark in Sreemangal',
		description: 'Located in Sreemangal, Hotel Skypark features a garden. Among the facilities at this property are a 24-hour front desk and a shared kitchen, along with free WiFi throughout the property. Their top floor.',
		imgUrl: 'https://i.ibb.co/684MBLt/hotel-4.jpg',
		bed: 4,
		capacity: 8,
		bedroom: 4,
		baths: 3,
		halfprice: 499,
		totalPrice: 579,
		ratings: 4.9,
		ratingsPerson: 13,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "sreemangal"
	},
	{	
		id: 106,
		hotelName: 'Hotel Paradise in Sreemangal',
		description: 'Located in Sreemangal, Hotel Paradise Sreemangal offers a garden. The property has a 24-hour front desk, airport transportation, room service and free WiFi.',
		imgUrl: 'https://i.ibb.co/5KH9xsZ/hotel-5.jpg',
		bed: 1,
		capacity: 2,
		bedroom: 1,
		baths: 1,
		halfprice: 179,
		totalPrice: 229,
		ratings: 4.9,
		ratingsPerson: 128,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "sreemangal"
	},
	{	
		id: 107,
		hotelName: 'Hotel Paradise in Sundarbans',
		description: 'Located in Sundarbans, Hotel Paradise Sreemangal offers a garden. The property has a 24-hour front desk, airport transportation, room service and free WiFi.',
		imgUrl: 'https://i.ibb.co/NnSKgnd/hotel-2.jpg',
		bed: 2,
		capacity: 4,
		bedroom: 2,
		baths: 2,
		halfprice: 229,
		totalPrice: 329,
		ratings: 4.9,
		ratingsPerson: 12,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "sundarbans"
	},
	{	
		id: 108,
		hotelName: 'Hotel Paradise in Coxs Bazar',
		description: 'Located in Coxs Bazar, Hotel Paradise Coxs Bazar offers a garden. The property has a 24-hour front desk, airport transportation, room service and free WiFi.',
		imgUrl: 'https://i.ibb.co/vBRY2Dr/Rectangle-26.png',
		bed: 1,
		capacity: 1,
		bedroom: 1,
		baths: 1,
		halfprice: 69,
		totalPrice: 99,
		ratings: 4.9,
		ratingsPerson: 129,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "coxsbazar"
	},
	{	
		id: 109,
		hotelName: 'Madhabilata Eco Cottage, Coxs Bazar',
		description: 'Madhabilata Eco Cottage is located in Coxs Bazar and features a bar, a garden and a terrace. Free WiFi is available. All rooms in the guesthouse are equipped with an electric tea pot.',
		imgUrl: 'https://i.ibb.co/HKVfdZj/Rectangle-27.png',
		bed: 2,
		capacity: 4,
		bedroom: 2,
		baths: 2,
		halfprice: 229,
		totalPrice: 329,
		ratings: 4.9,
		ratingsPerson: 69,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "coxsbazar"
	},
	{	
		id: 110,
		hotelName: 'Hotel Skypark in Coxs Bazar',
		description: 'Located in Coxs Bazar, Hotel Skypark features a garden. Among the facilities at this property are a 24-hour front desk and a shared kitchen, along with free WiFi throughout the property. Their top floo.',
		imgUrl: 'https://i.ibb.co/MGp5jNm/Rectangle-28.png',
		bed: 3,
		capacity: 6,
		bedroom: 3,
		baths: 3,
		halfprice: 329,
		totalPrice: 429,
		ratings: 4.9,
		ratingsPerson: 12,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "coxsbazar"
	},
	{	
		id: 111,
		hotelName: 'Hotel Skypark in Sundarbans',
		description: 'Located in Sundarbans, Hotel Skypark features a garden. Among the facilities at this property are a 24-hour front desk and a shared kitchen, along with free WiFi throughout the property. Their top floor garden.',
		imgUrl: 'https://i.ibb.co/MGp5jNm/Rectangle-28.png',
		bed: 2,
		capacity: 4,
		bedroom: 2,
		baths: 2,
		halfprice: 229,
		totalPrice: 329,
		ratings: 4.9,
		ratingsPerson: 12,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "sundarbans"
	},
	{	
		id: 112,
		hotelName: 'Hotel Skypark in Sundarbans',
		description: 'Located in Sundarbans, Hotel Skypark features a garden. Among the facilities at this property are a 24-hour front desk and a shared kitchen, along with free WiFi throughout the property. Their top floor.',
		imgUrl: 'https://i.ibb.co/5KH9xsZ/hotel-5.jpg',
		bed: 2,
		capacity: 4,
		bedroom: 2,
		baths: 2,
		halfprice: 229,
		totalPrice: 329,
		ratings: 4.9,
		ratingsPerson: 12,
		starImg: "https://i.ibb.co/ZBPsrjz/star-1.png",
		place: "sundarbans"
	}

];












const fakeData = [...hotelInfo];

const shuffle = a => {
    for (let i = a.length; i; i--) {
        let j = Math.floor(Math.random() * i);
        [a[i - 1], a[j]] = [a[j], a[i - 1]];
    }
}

shuffle(fakeData);

export default fakeData;



